import { DeleteOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button } from "antd";
import classes from "./AttachPersonToManagerCard.module.css";
import { IAttachPersonToManagerCardProps } from "../../../../interfaces/Ui/AdminManagerInfo/IAttachPersonToManagerCardProps";

export const AttachPersonToManagerCard = ({
  fullName,
  inn,
  fixDate,
  deleteButtonProps,
  className = "",
  loadingDelete = false,
}: IAttachPersonToManagerCardProps) => {
  return (
    <div className={`${classes.card} ${className}`}>
      <div className={classes.cardName}>{fullName}</div>
      <div className={classes.cardInn}>{inn}</div>
      <div className={classes.cardDate}>{fixDate}</div>

      <Button
        className={classes.deleteButton}
        size="small"
        {...deleteButtonProps}
        color="danger"
        variant="link"
      >
        {!loadingDelete ? <DeleteOutlined /> : <LoadingOutlined spin />}
      </Button>
    </div>
  );
};
